import { cloneDeep } from 'lodash';
import SearchRuleForm from './SearchRuleForm.vue';
import SearchTagList from './SearchTagList.vue';
import SearchOperatorToggle from './SearchOperatorToggle.vue';
import ContainerWithLabel from '@/components/core/ContainerWithLabel.vue';
import { prepareSearchForDisplayAsync, areRulesEqual, validateRule } from './Utils/rules';
export default {
  name: 'MultiSearch',
  components: {
    SearchRuleForm,
    SearchTagList,
    SearchOperatorToggle,
    ContainerWithLabel
  },
  props: {
    searchConfig: {
      type: Object,
      required: true,
      default: () => ({})
    },
    dense: {
      type: Boolean,
      default: false
    },
    showCondition: {
      type: Boolean,
      default: false
    },
    showOperator: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules: [],
      join: 'AND'
    };
  },
  computed: {
    operatorOptions() {
      return [{
        value: 'AND',
        text: this.$i18n_t('Core.MultiSearch.operators.and')
      }, {
        value: 'OR',
        text: this.$i18n_t('Core.MultiSearch.operators.or')
      }];
    },
    hasRules() {
      return this.rules.length > 0;
    },
    searchPayload() {
      if (!this.hasRules) {
        return null;
      }
      return {
        rules: cloneDeep(this.rules),
        join: this.join
      };
    }
  },
  methods: {
    addRule(rule) {
      if (!validateRule(rule, this.searchConfig)) {
        return;
      }
      const existingRule = this.rules.find(r => areRulesEqual(r, rule));
      if (existingRule) {
        return;
      }
      this.rules.push(rule);
      this.emitSearchUpdate();
    },
    removeRule(index) {
      if (index >= 0 && index < this.rules.length) {
        this.rules.splice(index, 1);
        this.emitSearchUpdate();
      }
    },
    onOperatorChange(operator) {
      this.join = operator;
      this.emitSearchUpdate();
    },
    emitSearchUpdate() {
      this.$emit('search-updated', this.searchPayload);
    },
    clearAllRules() {
      this.rules = [];
      this.join = 'AND';
      this.emitSearchUpdate();
    },
    async loadRules(persistedData) {
      try {
        const prepared = await prepareSearchForDisplayAsync(persistedData);
        this.rules = prepared.rules;
        this.join = prepared.join || 'AND';
        this.$nextTick(() => {
          this.emitSearchUpdate();
        });
      } catch (error) {
        console.error('Error loading rules:', error);
      }
    },
    addRuleFromExternal(rule) {
      this.addRule(rule);
    },
    getRules() {
      return cloneDeep(this.rules);
    },
    getSearchPayload() {
      return this.searchPayload;
    }
  }
};